import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WindowSizeService {
  private screenWidth$ = new BehaviorSubject<number>(window.innerWidth);

  constructor() {
    this.updateScreenWidth(window.innerWidth);

    // Update screen width on window resize
    window.addEventListener('resize', () => {
      this.updateScreenWidth(window.innerWidth);
    });
  }

  // Directly return the current screen width
  getCurrentScreenWidth(): number {
    return this.screenWidth$.value;
  }

  // Provide the screen width as an observable
  getScreenWidth(): Observable<number> {
    return this.screenWidth$.asObservable();
  }

  // Update the BehaviorSubject value
  private updateScreenWidth(width: number): void {
    this.screenWidth$.next(width);
  }
}
